import React from 'react'

const IconMoon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={{ marginRight: '-2px' }}
      width='26'
      height='26'
      viewBox='0 0 26 26'
      fill='none'
    >
      <g filter='url(#filter0_d_17652_22252)'>
        <rect y='1' width='24' height='24' rx='12' fill='white' />
        <mask
          id='mask0_17652_22252'
          style={{
            maskType: 'alpha',
          }}
          maskUnits='userSpaceOnUse'
          x='3'
          y='5'
          width='17'
          height='17'
        >
          <rect x='3' y='5' width='17' height='17' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_17652_22252)'>
          <path
            d='M14.303 10.6337L12.0554 8.38607L14.303 6.13867L16.5506 8.38607L14.303 10.6337ZM18.383 12.6737L17.1554 11.4461L18.383 10.2187L19.6106 11.4461L18.383 12.6737ZM11.9417 21.6004C10.8614 21.6004 9.84823 21.3955 8.90232 20.9856C7.95627 20.5758 7.13107 20.0187 6.4267 19.3143C5.72233 18.6099 5.16523 17.7847 4.75539 16.8387C4.34555 15.8928 4.14062 14.8796 4.14062 13.7993C4.14062 12.0246 4.67272 10.4385 5.73692 9.04078C6.80098 7.64324 8.20483 6.72489 9.94846 6.28572C9.80566 7.65011 9.94974 8.93411 10.3807 10.1377C10.8118 11.3413 11.4997 12.4155 12.4445 13.3603C13.3609 14.2767 14.4351 14.9469 15.6671 15.3709C16.899 15.7948 18.1617 15.9353 19.4553 15.7925C19.0391 17.5078 18.1264 18.9046 16.7172 19.9828C15.3082 21.0612 13.7164 21.6004 11.9417 21.6004ZM11.9394 20.4954C13.186 20.4954 14.3477 20.1766 15.4244 19.5391C16.501 18.9016 17.3156 18.0375 17.8681 16.9466C16.6923 16.8758 15.5696 16.5947 14.5 16.1032C13.4304 15.6118 12.4777 14.9481 11.6419 14.1123C10.7919 13.2623 10.126 12.3074 9.64437 11.2476C9.16271 10.1878 8.87937 9.06288 8.79437 7.87288C7.70354 8.45372 6.83938 9.27666 6.20188 10.3417C5.56438 11.4069 5.24563 12.5602 5.24563 13.8016C5.24563 15.661 5.89644 17.2414 7.19808 18.5429C8.49957 19.8446 10.08 20.4954 11.9394 20.4954Z'
            fill='black'
          />
        </g>
      </g>
      <defs>
        <filter
          id='filter0_d_17652_22252'
          x='0'
          y='0.5'
          width='25.5'
          height='25'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='1' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_17652_22252' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_17652_22252'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}

export default IconMoon
